import { Component, Prop, h, State, Listen } from '@stencil/core';
import { SvsTooltip } from '../../../../design-system/tooltip/svs-tooltip';

@Component({
  tag: 'uiaas-search-conversational-search-tooltip-reactivity-wrapper',
  styleUrl: 'tooltip-reactivity-wrapper.scss',
  shadow: true,
})
export class ConversationalSearchTooltipReactivityWrapper {
  @Prop() readonly text: string;

  @State() isVisible = false;

  private wasTooltipAlreadyTriggered = false;
  private tooltipTimeout: NodeJS.Timeout;

  @Listen('conversational-search:select-characteristics', { target: 'window' })
  handleCharacteristicsSelection(e) {
      const shouldTooltipBeVisible =
        e.detail?.characteristics &&
        !this.wasTooltipAlreadyTriggered;

      if (shouldTooltipBeVisible) {
        this.wasTooltipAlreadyTriggered = true;
        this.isVisible = true;
        this.invokeSetTimeout();
      }
  }

  @Listen('conversational-search:user-question-state', { target: 'window' })
  @Listen('conversational-search:user-new-conversation', { target: 'window' })
  handleNewConversation() {
      this.wasTooltipAlreadyTriggered = false;

      if (this.isVisible) this.isVisible = false;
  }

  private invokeSetTimeout() {
      this.tooltipTimeout = setTimeout(() => {
          this.isVisible = false;
      }, 4000);
  }

  private clearTimeout() {
      if (this.tooltipTimeout) clearTimeout(this.tooltipTimeout);
  }

  disconnectedCallback() {
      this.clearTimeout();
  }

  render() {
      return this.isVisible ? (
        <SvsTooltip text={this.text} />
      ) : (
        ''
      );
  }
}
